import React from 'react';
import copy from 'copy-to-clipboard';
import { getRetrospectiveUrl } from '../../utils/retrospectiveUrl';

import S from './style';

function CopyToClipboard({ id, handleCopyUrl, copied }) {
  const copyToClipboard = () => {
    (async () => {
      const url = await getRetrospectiveUrl(id);
      copy(url);
    })();
    handleCopyUrl(true);
    setTimeout(() => {
      handleCopyUrl(false);
    }, 1500);
  };

  return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions
    <span data-tip="" data-for={`linkto-${id}`} onClick={copyToClipboard}>
      {copied ? <S.CopiedIcon /> : <S.CopyIcon />}
    </span>
  );
}

export default CopyToClipboard;
